var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.basicHsbList && _vm.apparatusDetails
    ? _c(
        "div",
        [
          _c(
            "b-row",
            {
              staticClass: "mb-0 pb-0 current-plan",
              attrs: { "align-h": "center", "no-gutters": "" }
            },
            [
              _c("b-col", [
                _c(
                  "div",
                  {
                    staticClass: "row mb-3 ml-3 mr-3",
                    attrs: { "align-h": "around" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "text-center plan-details-header",
                        attrs: {
                          "data-test-hook": "new-plan-with-upgrade-text"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("xFuelMonitorRequiresPremiumWithHsb")
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _c("SubscriptionCard", {
            attrs: {
              "subscription-product": _vm.selectedProduct,
              "existing-apparatuses": [],
              "apparatuses-to-add": [_vm.apparatusDetails, ..._vm.basicHsbList],
              "is-new-plan": true,
              "monthly-paid-product": _vm.monthlyPaidProduct,
              "annual-paid-product": _vm.annualPaidProduct,
              "hide-badge": true
            },
            on: { setSelectedProduct: _vm.setSelectedProduct }
          }),
          _c(
            "b-row",
            { staticClass: "mt-3", attrs: { "no-gutters": "" } },
            [
              _c(
                "b-col",
                { staticClass: "float-left", attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: {
                        variant: "warning",
                        disabled: _vm.isCreatingPurchaseIntent,
                        "data-test-hook":
                          "subscription-new-tank-with-basic-confirm-plan-button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("openPayment")
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                      _vm.isCreatingPurchaseIntent
                        ? _c("b-spinner", { staticClass: "ml-2" })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }